// extracted by mini-css-extract-plugin
export var breadcrumb = "_0-2";
export var breadcrumbArrow = "_0-3";
export var breadcrumbs = "_0-0";
export var link = "_0-4";
export var small = "_0-1";